var _ = require('underscore'),
  React = require('react'),
  Moment = require('moment'),
  ClassNames = require('classnames');

var CustomPropTypes = require('../types.jsx'),
  Utils = require('../utils.jsx');

var ProgressTime = React.createClass({
  propTypes: {
    role: React.PropTypes.string.isRequired,
    time: React.PropTypes.number,
    duration: React.PropTypes.number,

    className: CustomPropTypes.ClassNameType
  },
  render: function () {
    var className = Utils.ClassNames('player-progress-time', this.props.className);
    return (
      <div className={ClassNames(className)}>
        <span>{Moment().minutes(0).seconds(this.props.time || 0).format('m:ss')}</span>
        <span>/</span>
        <span>{Moment().minutes(0).seconds(this.props.duration || 0).format('m:ss')}</span>
      </div>
    );
  }
});

module.exports = ProgressTime;



// WEBPACK FOOTER //
// ./src/app/components/progress/time.jsx